import { render, staticRenderFns } from "./CardUpdateRecord.vue?vue&type=template&id=5dda3b75&scoped=true"
import script from "./CardUpdateRecord.vue?vue&type=script&lang=js"
export * from "./CardUpdateRecord.vue?vue&type=script&lang=js"
import style0 from "./CardUpdateRecord.vue?vue&type=style&index=0&id=5dda3b75&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dda3b75",
  null
  
)

export default component.exports